import { DisclosureGroup } from 'react-aria-components';
import styled from 'styled-components';
import { sharedLinkStyles } from '@/components/Link/Link.styled';

export const Disclosures = styled(DisclosureGroup)`
  margin: 0 0 40px;
  border-top: 1px solid var(--grey-200);
  border-block-end: 1px solid var(--grey-200);

  @media (width >= 48rem) {
    margin-inline: 0;
  }

  & .react-aria-Disclosure {
    border-block-start: 1px solid var(--grey-200);

    &:first-of-type:has([hidden="until-found"]),
    &:has([aria-expanded="true"]) {
      &:not([data-focus-visible-within]) {
        border-block-start: none;
      }
    }

    &[data-focus-visible-within] {
      box-shadow: var(--shadow-focus);
      border: 1px solid var(--brand-600);

      & :focus-visible {
        outline: 0;
      }
    }
    
    & .react-aria-Heading {
      margin-block: 0;
    }

    & .react-aria-Button {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding-block: 16px;
      background: transparent;
      border: none;
      font-size: var(--font-size-text-lg);
      font-weight: var(--font-weight-medium);
      color: var(--black);

      & svg {
        width: 12px;
      }

      &[aria-expanded="true"] {
        border-block-end: 1px solid var(--grey-200);

        & svg path {
          transition: 0.2s;
          d: path("M5 12H19");
        }
      }
    }

    & .react-aria-DisclosurePanel {
      padding: 20px;

      &[hidden="until-found"] {
        padding: 0;
      }

      & p,
      & li,
      & dt,
      & dd {
        margin-block-end: var(--spacing-base);
        font-size: var(--font-size-text-md);
        font-weight: var(--font-weight-regular);
        color: var(--black);
        line-height: 1.5;
      }

      & dl {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-small);

        & > div {
          display: flex;
          flex-direction: row;
          gap: var(--spacing-small);

          & dt {
            margin-block-end: 0;
            font-weight: var(--font-weight-bold);
          }

          & dd {
            margin-block-end: 0;

            &:has(a) {
              display: flex;
              flex-direction: column;
            }
          }
        }
      }

      & a {
        ${sharedLinkStyles}
      }

      & img {
        max-width: 100%;
        height: auto;
      }
    }
  }
`;
